import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import config from '@plone/volto/registry';


declare global {
  interface Window {
    dataLayer: any[];
    __GTM_LOADED__?: boolean;
  }
}

const GTMProvider = () => {
  if(typeof window === 'undefined') {
    return null;
  }

  const location = useLocation();

  const gtmID = window.env?.RAZZLE_GTM_ID ?? 'GTM-XXXXXXX';
  const enabled = (gtmID !== 'GTM-XXXXXXX');

  console.log("loading gtm provider", gtmID, enabled);

  // Load GTM once
  useEffect(() => {
    if(!enabled || !gtmID) return;

    if(window.__GTM_LOADED__) return;
    window.__GTM_LOADED__ = true;

    // derived from the <script> snippet provided by gtm
    // the initial event to indicate to gtm that it should
    // start processing events in the container
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    });

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmID}`;

    document.head.appendChild(script);
  }, [gtmID, enabled]);

  // Track SPA route changes
  useEffect(() => {
    if (!enabled) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'pageview',
      page: location.pathname,
      title: document.title,
    });
  }, [location, enabled]);

  return null;
};

export default GTMProvider;
